<template>
  <div class="wraper">
    <div class="block" style="float:left;width: 100%;margin-bottom: 4px">
      <div style="padding-bottom: 10px">
        <el-breadcrumb separator=">">
          <el-breadcrumb-item :to="router">设备分组</el-breadcrumb-item>
          <el-breadcrumb-item>设备分组详情</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <el-row class='top'>
        <el-date-picker
          size='mini'
          v-model="date"
          type="daterange"
          align="right"
          unlink-panels
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :clearable='clearDate'
          :picker-options="pickerOptions"
        >
        </el-date-picker>
        <el-button size="mini" type="primary" @click='search'>查询</el-button>
        <el-button size="mini" type="danger" @click='deleteMore' title='批量删除所选数据'>批量删除</el-button>
        <div class="export_btn">
          <exporter
            :setting='setting'
            :url='getListUrl'
            :date='date'
          ></exporter>
        </div>
      </el-row>
      <deviceSearchBox
        :postParams='postParams'
        @getSearchSelect="searchTable"
      ></deviceSearchBox>
      <el-row>
        <report
          :setting='setting'
          :list='list'
          @freshList='handleSun'
          @callFather='selectList'
        ></report>
        <el-row class="pages">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 50, 100, 200]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </el-row>
      </el-row>
    </div>
  </div>
</template>

<script>
    import Report from '../../components/Report'
    import exporter from '../../components/exporter'
    import deviceSearchBox from '../devices/components/deviceSearchBox'

    export default {
        name: 'device',
        components: {
            Report,
            exporter,
            deviceSearchBox
        },
        data() {
            return {
                router: '/devices',
                getListUrl: '',
                date: this.getDefaultDay(),
                clearDate: false,
                postParams: {
                    areaCompany: '',
                    provinceBranchCompany: '',
                    productModelType: '',
                    agencyType: '',
                    channelType: '',
                    secondChannelType: '',
                    thirdChannelType: '',
                    dealerCompany: '',
                    city: '',
                    marketType: '',
                    province: '',
                    putPolicy: '',
                    store: '',
                    search: '',
                },
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() > Date.now() - (1000 * 60 * 60 * 24);
                    },
                    shortcuts: [{
                        text: '昨天',
                        onClick(picker) {
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24);
                            picker.$emit('pick', [start, start]);
                        }
                    }, {
                        text: '最近七天',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                },
                currentPage: 1,
                setting: {
                    isShowSelect: true,
                    isShowIndex: false,
                    tHeader: [{
                        dataItem: 'assetsNum',
                        dataName: '资产编号',
                        width: '200px'
                    }, {
                        dataItem: 'areaCompanyName',
                        dataName: '大区',
                        width: '120px'
                    }, {
                        dataItem: 'provinceBranchCompanyName',
                        dataName: '省区/分公司',
                        width: '160px'
                    }, {
                        dataItem: 'productModelType',
                        dataName: '冷柜系列',
                        width: '120px'
                    }, {
                        dataItem: 'channelTypeName',
                        dataName: '渠道类型',
                        width: '120px'
                    }, {
                        dataItem: 'secondChannelTypeName',
                        dataName: '二级渠道类型',
                        width: '150px'
                    }, {
                        dataItem: 'thirdChannelTypeName',
                        dataName: '三级渠道类型',
                        width: '150px'
                    }, {
                        dataItem: 'marketTypeName',
                        dataName: '市场类型',
                        width: '120px'
                    }, {
                        dataItem: 'businessCompanyName',
                        dataName: '经销商名称',
                        width: '120px'
                    }, {
                        dataItem: 'dealerCompanyName',
                        dataName: '网点名称',
                        width: '200px'
                    }, {
                        dataItem: 'storeName',
                        dataName: '客户类型',
                        width: '200px'
                    }, {
                        dataItem: 'provinceName',
                        dataName: '省份',
                        width: '100px'
                    }, {
                        dataItem: 'cityName',
                        dataName: '城市',
                        width: '100px'
                    },
                        {
                            dataItem: 'putPolicyName',
                            dataName: '投放策略',
                            width: '200px'
                        }],
                    isShowPlay: true,
                    isShowDelBtn: true,
                    isShowEditBtn: false,
                    isShowInfoBtn: false,
                    infoUrl: 'deviceDetail',
                    groupId: ''
                },
                list: [],
                total: 0,
                pageSize: 10,
                urlParams: {},
                imei: ''
            }
        },
        mounted() {
            this.urlParams = this.$route.query;
            this.getListUrl = this.urlParams.url;
            this.setting.groupId = this.urlParams.groupId;
            this.getList(this.urlParams, this.postParams)
        },
        methods: {
            getDefaultDay() {
                let date = new Date();
                date = new Date(date.getTime() - 1000 * 60 * 60 * 24 * 6);
                let year = date.getFullYear();
                let month = date.getMonth() + 1;
                if (month < 10) {
                    month = "0" + month;
                }
                let day = date.getDate();
                if (day < 10) {
                    day = "0" + day;
                }
                date = year + '-' + month + '-' + day;
                return [date, date];
            },
            getList(p, paramsObj) {
                let url = p.url;
                let params = {
                    groupId: p.groupId,
                    pageSize: this.pageSize,
                    pageNum: this.currentPage,
                    startDay: this.date[0],
                    endDay: this.date[1]
                };
                for (let k in paramsObj) {
                    if (paramsObj[k] != '')
                        params[k] = paramsObj[k];
                }
                let _this = this;
                this.$ajax.post(url, params)
                    .then(this.getListSucc)
                    .catch(function (res) {
                        _this.$message.error('哎呀~网络异常了呢');
                    })
            },
            getListSucc(res) {
                if (res.data && res.data.code === 200) {

                    const data = res.data.data;
                    this.list = data.list;
                    this.total = data.total;
                    console.log(this.list)
                } else {
                    let errMsg = '未知错误'
                    if (res.data.msg) {
                        errMsg = res.data.msg;
                    }
                    this.$message.error(errMsg);
                }
            },
            search() {
                this.getList(this.urlParams, this.postParams)
            },
            handleSizeChange(val) {
                // console.log('每页 '+val+' 条');
                this.pageSize = val;
                this.currentPage = 1;
                this.getList()
                // console.log(this.pageSize);
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.getList()
            },
            handleSun() {
                this.getList(this.urlParams, this.postParams)
            },
            searchTable() {
                //console.log(this.postParams)
                this.getList(this.urlParams, this.postParams)
            },
            selectList(res) {
                var str = ''
                for (var i = 0; i < res.length; i++) {
                    str += res[i].assetsNum + ','
                }
                if (str.length > 0) {
                    str = str.substr(0, str.length - 1);
                }
                this.imei = str;
            },
            deleteMore() {
                if (this.imei.length === 0) {
                    this.$message.warning('请选择数据');
                    return;
                }
                var msg = "是否删除设备 [" + this.imei + "] ?";
                var params = {
                    groupId: this.setting.groupId,
                    assetsNums: this.imei
                }
                var url = 'http://metadata-test.zhiquyun.cn/datatranslate/data/deleteGroupRelative'
                this.$confirm(msg, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$ajax.post(url, params).then((res) => {
                        if (res.data.code == 200) {
                            this.$message({
                                message: '已删除',
                                type: 'success'
                            });
                            this.getList(this.urlParams, this.postParams)
                        } else {
                            this.$message.error(res.data.msg);
                        }
                    }).catch((err) => {
                        this.$message.error('请求失败')
                    })
                }).catch(() => {
                });
            }
        }
    }
</script>
<style scoped>
  .top {
    height: 50px;
  }

  .pages {
    padding-top: 10px;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/pages/devices/devicesDetail.vue